// extracted by mini-css-extract-plugin
export var alignCenter = "_a8-d";
export var bannerShown = "_a8-6";
export var buttonContent = "_a8-0";
export var cardList = "_a8-1";
export var centerContent = "_a8-2";
export var chevron = "_a8-3";
export var closePanelButton = "_a8-k";
export var conversationContextContainer = "_a8-l";
export var conversationDetailContainer = "_a8-4";
export var detailWrapper = "_a8-7";
export var dropdownButton = "_a8-e";
export var dropdownTitle = "_a8-9";
export var fullHeight = "_a8-5";
export var hidden = "_a8-a";
export var icon = "_a8-b";
export var mergeSuggestionWrapper = "_a8-m";
export var panel = "_a8-i";
export var portalButtonsWrapper = "_a8-c";
export var right = "_a8-j";
export var tableSummaryContainer = "_a8-8";
export var tableSummaryHeader = "_a8-g";
export var threeDotsButton = "_a8-f";
export var wide = "_a8-h";